import { render, staticRenderFns } from "./DiagramBarChart.vue?vue&type=template&id=be867aae"
import script from "./DiagramBarChart.vue?vue&type=script&lang=js"
export * from "./DiagramBarChart.vue?vue&type=script&lang=js"
import style0 from "./DiagramBarChart.vue?vue&type=style&index=0&id=be867aae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports